import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const SmartScheduler = () =>{
    return(
        <>
        <WrapperLayout>
            <Main/>
        </WrapperLayout>
    </>
    )
}
export default SmartScheduler